import { render, staticRenderFns } from "./UserGroupCustomDetail.vue?vue&type=template&id=a967218e&scoped=true&"
import script from "./UserGroupCustomDetail.vue?vue&type=script&lang=ts&"
export * from "./UserGroupCustomDetail.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupCustomDetail.vue?vue&type=style&index=0&id=a967218e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a967218e",
  null
  
)

export default component.exports